import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiRequest } from '../../utils/apiConfig';
import './PlayersPanel.scss';

const PlayersPanel = () => {
    const [playersData, setPlayersData] = useState({
        online: 0,
        players: [],
        updatedAt: null
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchPlayers = async () => {
        try {
            setError(null);
            const response = await apiRequest('/players');
            const data = await response.json();
            setPlayersData(data);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPlayers();
        const interval = setInterval(fetchPlayers, 30000); // Refresh every 30 seconds
        return () => clearInterval(interval);
    }, []);

    if (loading) {
        return (
            <div className="players-panel">
                <h1>Minecraft Players Online</h1>
                <p>Loading...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="players-panel">
                <h1>Minecraft Players Online</h1>
                <p className="error">Error: {error}</p>
                <button onClick={fetchPlayers}>Retry</button>
            </div>
        );
    }

    return (
        <div className="players-panel">
            <h1>Minecraft Players Online</h1>
            <div className="online-count">
                Online: {playersData.online} (updated {playersData.updatedAt ? new Date(playersData.updatedAt).toLocaleTimeString() : 'N/A'})
            </div>
            <ul className="players-list">
                {playersData.players.map((player, index) => (
                    <li key={index}>
                        <Link to={`/${encodeURIComponent(player)}`} className="player-link">
                            {player}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PlayersPanel;